import { HotLeadDataView, useHotLeadData } from 'hooks/Recommendation/useHotLeadData'
import { shallowEqual, useAppSelector } from 'hooks/reduxHooks'
import { useParams } from 'react-router'
import { isMobileAppSel } from 'selectors/configSelectors'
import { getFirstHotLead } from 'selectors/recomendations/hotLeadSelectors'

export default function useHotLeadSelectionLogic(
  { hotLeadCardEnabled }:{hotLeadCardEnabled: boolean},
): {
  isHotLeadDataReady: boolean,
  canShowHotLead: boolean,
  hotLeadData?: HotLeadDataView,
  } {
  const {
    hotLead,
    isInMobileWebView,
  } = useAppSelector((state) => ({
    hotLead: getFirstHotLead(state),
    isInMobileWebView: isMobileAppSel(state),
  }), shallowEqual)

  // the offerId from the URL, which comes from the offer page
  // so if the ID is the same as offer page ID, we don't show the card
  const { offerId: offerPageOfferId } = useParams<{offerId: string}>()
  const isViewingOfferPage = !!hotLead.offerId && (hotLead.offerId === offerPageOfferId)

  const canUseHotLeadData = (
    !isInMobileWebView &&
    !!hotLead.offerId &&
    hotLeadCardEnabled &&
    !isViewingOfferPage &&
    false // disalbe HL card for now while doing AB testing
  )

  // we still need to use HL data when it is dismissed so we can render exit animation
  const { hotLeadData, hotLeadDataReady } = useHotLeadData(hotLead, canUseHotLeadData)

  const canShowHotLead = canUseHotLeadData && !hotLead.isDismissed && (!hotLeadDataReady || !!hotLeadData)

  const isHotLeadDataReady = !canUseHotLeadData || !canShowHotLead || hotLeadDataReady

  return {
    isHotLeadDataReady,
    canShowHotLead,
    hotLeadData,
  }
}
